import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { saveAs } from 'file-saver';
import {randomString} from "./Common";

const makePDF = () => {
  const converToImg = async (sclass) => {
    // html to imageFile
    const paper = document.querySelector("."+sclass);
    const canvas = await html2canvas(paper);
    const imageFile = canvas.toDataURL("image/png", 1.0);
    return imageFile;
  }

  const converToPDF = (imageFile,imode,setPromiseInProgress) => {
    // imageFile to pdf
    const mobileType = navigator.userAgent.toLowerCase();
    const doc = new jsPDF("p", "mm", "a4");
    (async () => {
      const data = await fetch(imageFile);
      const blob = await data.blob();
      const reader = new FileReader();
      reader.onload = () => {
        const base64data = reader.result;
        const imgWidth = doc.internal.pageSize.getWidth();
        //const pageHeight = doc.internal.pageSize.getHeight();
        const image_prop = doc.getImageProperties(imageFile);
        const pageHeight = 295;
        var imgHeight = image_prop.height * imgWidth / image_prop.width;
        var heightLeft = imgHeight;
        var position = 0;
        doc.addImage(base64data, 'PNG', 0, position, imgWidth, imgHeight); 
        heightLeft -= pageHeight;
        while (heightLeft >= 0) {
          position = heightLeft - imgHeight;
          doc.addPage();
          doc.addImage(base64data, 'PNG', 0, position, imgWidth, imgHeight);
          heightLeft -= pageHeight;
        }

        let filename = "마마몽떼 ";
        if(imode === 2) filename = "플라이";
        filename += "진도표"+randomString(5)+".pdf";
        setPromiseInProgress(false);
        if (mobileType.indexOf('android') > -1) {
          if(window.mamamonteP){
            /* const pdfDataUri = doc.output("datauristring");
            const pureBase64 = pdfDataUri.split(',')[1];
            window.mamamonteP.downloadBase64File(pureBase64, filename, 'application/octet-stream'); */
            //const pdf = new File([doc.output("blob")], filename, {type: "application/pdf"});
            //window.mamamonteP.downloadBase64File(pdf);

            // // 수정전
            // window.mamamonteP.downloadBase64File(doc.output("blob"), filename, 'application/octet-stream');
            // alert('다운로드가 완료되었습니다.');
            // 수정 후
            doc.output("blob").arrayBuffer().then((arrayBuffer) => {
              const base64String = btoa(
                new Uint8Array(arrayBuffer)
                  .reduce((data, byte) => data + String.fromCharCode(byte), '')
              );
              window.mamamonteP.downloadBase64File(base64String, filename, 'application/pdf');
              alert('다운로드가 완료되었습니다.');
            });
          }
        } else {
          saveAs(doc.output("blob"), filename);
        } 
      }
      reader.readAsDataURL(blob);
    })();
  }

  return {
    viewWithPDF: async (sclass,imode,setPromiseInProgress) => {
      // html to imageFile
      setPromiseInProgress(true);
      const imageFile = await converToImg(sclass);
      // imageFile to PDF
      //const pdf = converToPDF(imageFile);
      converToPDF(imageFile,imode,setPromiseInProgress);
    }
  }

}

export default makePDF
